module.exports = "tr{line-height:25px;min-height:25px;height:25px}\n"